import React, { useState, useEffect } from 'react';

export const dashStats = [
    {
        'Stat': 'Viewed You',
        'LastLogin': 15,
        'ThisWeek': 31,
        'IconPath': '../../assets/ViewedYou.png'
    },
    {
        'Stat': 'Favored You',
        'LastLogin': 5,
        'ThisWeek': 9,
        'IconPath': 'heart'
    }
]

export const profilePic1 = require('../../assets/profilePics/pic1.png');
export const profilePic2 = require('../../assets/profilePics/pic2.png');
export const profilePic3 = require('../../assets/profilePics/pic3.png');
export const profilePic4 = require('../../assets/profilePics/pic4.png');
export const profilePic5 = require('../../assets/profilePics/pic5.png');
export const profilePic6 = require('../../assets/profilePics/pic6.png');
export const profilePic7 = require('../../assets/profilePics/pic7.png');
export const profilePic8 = require('../../assets/profilePics/pic8.png');

export const matchData = [
    {
        'id':1,
        'pos':'1',
        'bookmarked':true,
        'saved':true,
        'fullName': 'Jane Doe',
        'gender': 'Female',
        'image': profilePic1,
        'age': 28,
        'percentageMatch': '90%',
        'favored': true,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    },
    {
        'id':2,
        'pos':'2',
        'bookmarked':true,
        'saved':false,
        'fullName': 'Natasha Smith',
        'gender': 'Female',
        'image': profilePic2,
        'age': 31,
        'percentageMatch': '93%',
        'favored': false,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    },
    {
        'id':3,
        'pos':'3',
        'bookmarked':false,
        'saved':true,
        'fullName': 'Jamie Johnson',
        'gender': 'Female',
        'image': profilePic3,
        'age': 34,
        'percentageMatch': '95%',
        'favored': true,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    },
    {
        'id':4,
        'pos':'4',
        'bookmarked':true,
        'saved':false,
        'fullName': 'Natalie Allen',
        'gender': 'Female',
        'age': 29,
        'image': profilePic4,
        'percentageMatch': '98%',
        'favored': false,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    },
    {
        'id':5,
        'pos':'5',
        'bookmarked':true,
        'saved':true,
        'fullName': 'Jane Doe',
        'gender': 'Female',
        'image': profilePic5,
        'age': 28,
        'percentageMatch': '80%',
        'favored': true,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    },
    {
        'id':6,
        'pos':'6',
        'bookmarked':true,
        'saved':true,
        'fullName': 'Natasha Smith',
        'gender': 'Female',
        'image': profilePic6,
        'age': 31,
        'percentageMatch': '83%',
        'favored': false,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    },
    {
        'id':7,
        'pos':'7',
        'bookmarked':false,
        'saved':true,
        'fullName': 'Jamie Johnson',
        'gender': 'Female',
        'image': profilePic7,
        'age': 34,
        'percentageMatch': '75%',
        'favored': true,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    },
    {
        'id':8,
        'pos':'8',
        'bookmarked':true,
        'saved':true,
        'fullName': 'Natalie Allen',
        'gender': 'Female',
        'age': 29,
        'image': profilePic8,
        'percentageMatch': '78%',
        'favored': false,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    }
];

export const matchDataOther = [
    {
        'id':5,
        'pos':'5',
        'fullName': 'Jane Doe',
        'gender': 'Female',
        'image': profilePic5,
        'age': 28,
        'percentageMatch': '80%',
        'favored': true,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    },
    {
        'id':6,
        'pos':'6',
        'fullName': 'Natasha Smith',
        'gender': 'Female',
        'image': profilePic6,
        'age': 31,
        'percentageMatch': '83%',
        'favored': false,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    },
    {
        'id':7,
        'pos':'7',
        'fullName': 'Jamie Johnson',
        'gender': 'Female',
        'image': profilePic7,
        'age': 34,
        'percentageMatch': '75%',
        'favored': true,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    },
    {
        'id':8,
        'pos':'8',
        'fullName': 'Natalie Allen',
        'gender': 'Female',
        'age': 29,
        'image': profilePic8,
        'percentageMatch': '78%',
        'favored': false,
        'lastMsg': 'wanna chat?',
        'catchphrase': 'I am really cool to talk to',
    }
];


export const viewingHistoryData = [
    {
        'fullName': 'Jane Doe',
        'gender': 'Female',
        'profilePic': profilePic5,
        'age': 25,
        'bookmarked': true
    },
    {
        'fullName': 'Natasha Smith',
        'gender': 'Female',
        'profilePic': profilePic6,
        'age': 28,
        'bookmarked': false
    },
    {
        'fullName': 'Jamie Johnson',
        'gender': 'Female',
        'profilePic': profilePic7,
        'age': 30,
        'bookmarked': true
    }
]

